<p-dialog
  [(visible)]="showDialog"
  (onHide)="cancelDialog()"
  [style]="{ width: '40vw' }"
  [appendTo]="'body'"
  [modal]="true"
  [styleClass]="'edit-product-dialog'"
  [maximizable]="true"
  [header]="translationKeys.editProductDialogComponent.html.dialogTitle | translate"
>
  <avano-table
    [tableConfiguration]="tableConfig"
    [headerText]="translationKeys.editProductDialogComponent.html.productsTable.tableTitle | translate"
    [tableRef]="editProductTable"
    [tableCollapsed]="true"
    class="selected-products-table"
  >
    <p-table
      #editProductTable
      [columns]="columns"
      [value]="products"
      [scrollable]="true"
      scrollHeight="230px"
      [paginator]="true"
      [rows]="10"
      [resizableColumns]="true"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            *ngFor="let col of columns; let i = index"
            [avanoTableColumnHeader]="col"
            [isLastSortable]="i === columns.length - 1"
            class="scip-avano-table-no-resize-filter"
          ></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            <div avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
              {{ rowData | nestedProperty: col.field }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </avano-table>
  <div class="edit-field-container">
    <div class="form-field">
      <label for="organisations">{{ translationKeys.editProductDialogComponent.html.organization | translate }}</label>
      <p-autoComplete
        id="organisations"
        [field]="'name'"
        [(ngModel)]="selectedOrganization"
        [suggestions]="organizationsSuggestions"
        (completeMethod)="filterOrganizations($event)"
        [dropdown]="true"
        [forceSelection]="true"
      >
      </p-autoComplete>
      <span class="error-message" *ngIf="selectedOrganization && !selectedOrganization.verified">
        {{ translationKeys.uploadProductDialogComponent.html.notVerifyOrganization | translate }}
      </span>
      <span class="error-message" *ngIf="selectedOrganization && selectedOrganization.verified && selectedOrganization.validationErrors">
        {{ translationKeys.uploadProductDialogComponent.html.verifyFailOrganization | translate }}
      </span>
    </div>
    <div class="form-field">
      <avano-radio-checkbox-group [label]="translationKeys.editProductDialogComponent.html.requestType | translate" [alignHorizontal]="true">
        <avano-radiobutton *ngFor="let requestedType of requestedTypes" [value]="requestedType.key" [(ngModel)]="selectedRequestedType">{{
          requestedType.name | translate
        }}</avano-radiobutton>
      </avano-radio-checkbox-group>
    </div>
    <div class="form-field">
      <label>{{ translationKeys.editProductDialogComponent.html.otherName | translate }}</label>
      <p-autoComplete [(ngModel)]="otherArticleNames" name="otherName" avanoSelectFieldMultiple (selectButtonClick)="openOtherNameDialog()">
        <ng-template let-otherName pTemplate="selectedItem">
          <span class="p-autocomplete-token-label"> {{ otherName | otherNameLabel | translate }}: {{ otherName.text }} </span>
        </ng-template>
      </p-autoComplete>
    </div>
    <div class="form-field">
      <label for="inEUTypes">{{ translationKeys.editProductDialogComponent.html.acInEuTypes | translate }}</label>
      <p-autoComplete
        id="inEUTypes"
        [field]="'label'"
        [(ngModel)]="selectedEUType"
        [suggestions]="inEUTypeSuggestions"
        (completeMethod)="filterInEUTypes($event)"
        [dropdown]="true"
        [forceSelection]="true"
      >
      </p-autoComplete>
    </div>
    <div class="form-field">
      <label>{{ translationKeys.editProductDialogComponent.html.acArticleArticleCategory | translate }} </label>
      <p-autoComplete
        [(ngModel)]="articleCategories"
        name="articleCategoriesChips"
        avanoSelectFieldMultiple
        (selectButtonClick)="openInformationArticleCategoryDialog()"
      >
        <ng-template let-value pTemplate="selectedItem">
          <span class="p-autocomplete-token-label" [title]="value | articleCategoryChip: true">{{ value | articleCategoryChip }}</span>
        </ng-template>
      </p-autoComplete>
    </div>
  </div>
  <div class="form-field">
    <avano-radio-checkbox-group [label]="translationKeys.editProductDialogComponent.safeuseinstructions.groupDescription | translate" [alignHorizontal]="true">
      <avano-radiobutton [(ngModel)]="provideSUI" [value]="false">{{
        translationKeys.editProductDialogComponent.safeuseinstructions.radioButtonLabel.noNeedToProvide | translate
      }}</avano-radiobutton>
      <avano-radiobutton [(ngModel)]="provideSUI" [value]="true">{{
        translationKeys.editProductDialogComponent.safeuseinstructions.radioButtonLabel.provide | translate
      }}</avano-radiobutton>
    </avano-radio-checkbox-group>
  </div>
  <avano-divider></avano-divider>
  <div class="form-field">
    <textarea
      avanoInputTextarea
      [label]="translationKeys.editProductDialogComponent.safeuseinstructions.textAreaLabel.safeUseInstructionText | translate"
      [isExpandingTextField]="true"
      maxlength="2000"
      [(ngModel)]="safeUseInstructionsText"
    ></textarea>
  </div>
  <ng-template pTemplate="footer">
    <button
      type="button"
      avanoButton
      [label]="translationKeys.commonTranslationKey.btn.cancel | translate"
      (click)="cancelDialog()"
      [icon]="'icon-content-cancel'"
    ></button>
    <button
      type="button"
      avanoButton
      [callToAction]="true"
      [label]="translationKeys.commonTranslationKey.btn.save | translate"
      (click)="saveProductEdits()"
      [icon]="'icon-content-check'"
    ></button>
  </ng-template>
</p-dialog>

<scip-article-category-select-dialog
  *ngIf="displayArticleCategorySelection"
  [selectedCategories]="articleCategories"
  (saveEvent)="saveArticleCategory($event)"
  (cancelEvent)="closeArticleCategoryDialog()"
></scip-article-category-select-dialog>

<scip-other-name-dialog
  *ngIf="displayOtherNameSelection"
  [otherNames]="otherArticleNames"
  (saveEvent)="saveOtherName($event)"
  (cancelEvent)="closeOtherNameDialog()"
></scip-other-name-dialog>
